export const PeopleType = {
  DESTINATION_PROMOTER: 'DESTINATION_PROMOTER',
  OTHER_PROMOTER: 'OTHER_PROMOTER',
  OTHER: 'OTHER',

  values: () => {
    return ['DESTINATION_PROMOTER', 'OTHER_PROMOTER', 'OTHER'];
  }
};
